import React from "react";
import { NavLink } from "react-router";
import { CartProvider, useCart } from "react-use-cart";
function Navbar() {
  const { totalItems } = useCart();
  return (
    <CartProvider>
      <nav
        className="custom-navbar navbar navbar navbar-expand-md navbar-dark bg-dark"
        arial-label="Furni navigation bar"
      >
        <div className="container">
          <NavLink className="navbar-brand" to="/">
            Furni<span>.</span>
          </NavLink>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarsFurni"
            aria-controls="navbarsFurni"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarsFurni">
            <ul className="custom-navbar-nav navbar-nav ms-auto mb-2 mb-md-0">
              <li className="nav-item ">
                <NavLink className="nav-link " to="/" >
                  Home
                </NavLink>
              </li>
              <li>
                <NavLink className="nav-link" to="/shop">
                  Shop
                </NavLink>
              </li>
              <li>
                <NavLink className="nav-link" to="/aboute">
                  About us
                </NavLink>
              </li>
              <li>
                <NavLink className="nav-link" to="/services">
                  Services
                </NavLink>
              </li>
              <li>
                <NavLink className="nav-link" to="/blog">
                  Blog
                </NavLink>
              </li>
              <li>
                <NavLink className="nav-link" to="/contact">
                  Contact us
                </NavLink>
              </li>
            </ul>

            <ul className="custom-navbar-cta navbar-nav mb-2 mb-md-0 ms-5">
              <li>
                <NavLink className="nav-link" to="/">
                  <img src="images/user.svg" />
                </NavLink>
              </li>
              <li>
                <NavLink className="nav-link" to="/pasket">
                  <img src="images/cart.svg" />
                  <span
                    style={{
                      color: "red",
                      padding: "2px",
                      fontStyle: "bold",
                      backgroundColor: "rgba(171, 158, 158, 0.71)",
                      borderRadius: "50%",
                      marginLeft: "0px",
                     
                    }}
                  >
                    {totalItems}
                  </span>
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      
    </CartProvider>
  );
}

export default Navbar;
